(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('#header-group')
    || document.querySelector('.shopify-section-group-header-group.dm-section:not(.dropmagic-style)');
  if (!header) return;

  header.style.setProperty('--dm-header-h', header.offsetHeight + 'px');

  let lastScrollTop = 0;

  function handleScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll === 0 || currentScroll < lastScrollTop) {
      header.classList.remove('hidden-header');
    } else {
      header.classList.add('hidden-header');
    }

    lastScrollTop = Math.max(currentScroll, 0);
  }

  window.addEventListener('scroll', handleScroll);
});
          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
